import { faArrowLeft, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchUserProfile } from '../components/api';
import RecipeCard from '../components/Recipe-card';

function PublicProfile() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserProfile(userId)
      .then((data) => {
        setProfile(data);
        setRecipes(data.recipes || []);
      })
      .catch((err) => {
        console.error('Error fetching profile:', err);
        setError('User profile not found');
      })
      .finally(() => setLoading(false));
  }, [userId]);

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (error || !profile) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-8 space-y-6">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition"
        >
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </button>
        <div className="bg-red-50 border border-red-200 rounded-2xl p-8 text-center">
          <p className="text-red-700">{error || 'User not found'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-6 py-8 space-y-8">
      <button
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition"
      >
        <FontAwesomeIcon icon={faArrowLeft} /> Back
      </button>

      {/* Profile Header */}
      <div className="bg-gradient-to-br from-orange-50 via-white to-purple-50 border border-gray-100 rounded-3xl p-8 flex flex-col md:flex-row items-center gap-8">
        {profile.photoURL && (
          <img
            src={profile.photoURL}
            alt={profile.name}
            className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg"
          />
        )}
        <div className="flex-1 text-center md:text-left space-y-2">
          <h1 className="text-4xl font-bold text-gray-900">{profile.name}</h1>
          <p className="text-sm text-gray-500">@{profile.uid}</p>
          {recipes.length > 0 && (
            <p className="text-sm text-gray-500">
              Published {recipes.length} recipe{recipes.length !== 1 ? 's' : ''}
            </p>
          )}
        </div>
      </div>

      {/* Recipes Section */}
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <FontAwesomeIcon icon={faUtensils} className="text-orange-500 text-lg" />
          <h2 className="text-2xl font-bold text-gray-900">
            {recipes.length > 0 ? `Recipes by ${profile.name}` : 'No recipes published yet'}
          </h2>
        </div>

        {recipes.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {recipes.map((recipe) => (
              <RecipeCard key={recipe.id} recipe={recipe} showCTA />
            ))}
          </div>
        ) : (
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-12 text-center">
            <p className="text-gray-600">This chef hasn't shared any recipes yet.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicProfile;
